export class LoadDatabase {
  static readonly type = '[Core] LoadDatabase';

  constructor() {
  }
}

export class LoadCountries {
  static readonly type = '[Core] LoadCountries';

  constructor() {
  }
}

export class LoadUniversities {
  static readonly type = '[Core] LoadUniversities';

  constructor() {
  }
}

export class LoadUniversityFields {
  static readonly type = '[Core] LoadUniversityFields';

  constructor() {
  }
}

export class GetUniversityFieldMinMax {
  static readonly type = '[Core] GetUniversityFieldMinMax';

  constructor(public field: string) {
  }
}

export class LoadRankFields {
  static readonly type = '[Core] LoadRankFields';

  constructor() {
  }
}

export class LoadFiltered {
  static readonly type = '[Core] LoadFiltered';

  constructor(public payload: any) {
  }
}

export class LoadVisualizations {
  static readonly type = '[Core] LoadVisualizations';

  constructor() {
  }
}

export class CheckFilters {
  static readonly type = '[Core] CheckFilters';

  constructor(public filters: any) {
  }
}

export class ShowTutorial {
  static readonly type = '[Core] ShowTutorial';

  constructor(public show: boolean) {
  }
}
